import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import IconAlert from '../../../components/Alert/IconAlert';
import ActionType from '../../../redux/reducer/globalActionType';
import API_AUTHENTICATION from '../../../api/apiAuthentication';

class GrochatMigration extends Component {
    postGrochatAccountMigrate = () => {
        if (this._isMounted) {
            const params = new URLSearchParams(this.props.location.search);
            let token = params.get('token');
            token = token.slice(0, token.length - 1);
            return API_AUTHENTICATION.postGrochatAccountMigrate(token)
        }
    }

    postDataLogout = () => {
        if (this._isMounted) {
            let token = localStorage.getItem('token');
            return API_AUTHENTICATION.postDataLogout(token)
        }
    }

    handleLogout = () => {
        if (this._isMounted) {
            localStorage.clear();
            return this.props.handleLogout();
        }
    }

    handleMigrateAccount = async () => {
        await this.postGrochatAccountMigrate();
        await this.postDataLogout();
        await this.handleLogout();

        localStorage.setItem('isGrochatAccountMigrated', true);
        setTimeout(() => window.close(), 500);
    }

    componentDidMount() {
        this._isMounted = true;

        this.handleMigrateAccount();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <div className="w-screen h-screen justify-center items-center text-center">
                <div className="w-full h-full flex flex-col justify-center">
                    <div className="flex justify-center mb-3"><IconAlert icon="success" /></div>
                    <p className="text-2xl font-medium whitespace-normal mb-3">Berhasil migrasi akun NexCare!</p>
                    <p className="text-xl whitespace-normal">Halaman ini akan tertutup dalam beberapa saat...</p>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GrochatMigration));